var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('quill-editor-local',{ref:"myQuillEditor",staticClass:"canvas",attrs:{"options":_vm.editorOption,"create-image":_vm.createImage},on:{"change":function($event){return _setup.onEditorChange($event)}},model:{value:(_setup.content),callback:function ($$v) {_setup.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }